/**
 * ParentTemplate
 */

import React from 'react';
import PropTypes from 'prop-types';
import useLocaleContext from 'containers/LanguageProvider/useLocaleContext.js';
import Page from './Page.jsx';
import HowToUse from './HowToUse.jsx';

function ParentTemplate(props) {
  const { locale } = useLocaleContext();
  const { users, language = locale } = props;

  const pages = users.map((user) => language === 'nl' ? (
    <Page header greeting footer key={user.code}>
      <p>Beste ouder/verzorger,</p>
      <p>
        Communicatie tussen school en ouders/verzorgers vinden wij erg belangrijk.
        Daarbij is ons doel je zo goed mogelijk te betrekken bij de verschillende activiteiten van onze school.
        Daarom maken wij gebruik van Social Schools 3.0 waarmee wij je via de app, e-mail en/of pushberichten
        direct en betrouwbaar kunnen bereiken.
      </p>
      <p>Hieronder vind je de koppelcode die je nodig hebt om je kind aan je persoonlijke account te koppelen:</p>
      <ul className="list-unstyled mt-3 mb-4 ps-5">
        <li className="my-2">
          <span className="def-label">Ouder/verzorger van:</span>
          {user.studentName}
        </li>
        <li className="my-2">
          <span className="def-label">Klas:</span>
          {user.groups.join(', ')}
        </li>
        <li className="my-2 fw-semibold">
          <span className="def-label">Koppelcode:</span>
          <samp>{user.code}</samp>
        </li>
      </ul>
      <HowToUse locale="nl">
        <p>Je kunt meerdere kinderen aan je account koppelen, zo houd je alle informatie bij elkaar:</p>
      </HowToUse>
    </Page>
  ) : (
    <Page header greeting footer key={user.code}>
      <p>Dear parent/guardian,</p>
      <p>
        We find communication between you and our school very important.
        Our aim is to involve you as much as possible in all activities.
        The Social Schools platform enables us to inform you directly and reliably through
        mobile or web app, by email and/or by push notifications.
      </p>
      <p>Please find the unique code that connects the profile of your child to your personal account:</p>
      <ul className="list-unstyled mt-3 mb-4 ms-5">
        <li className="my-2">
          <span className="def-label">Parent/guardian of:</span>
          {user.studentName}
        </li>
        <li className="my-2">
          <span className="def-label">Class:</span>
          {user.groups.join(', ')}
        </li>
        <li className="my-2 fw-semibold">
          <span className="def-label">Connection Code:</span>
          <samp>{user.code}</samp>
        </li>
      </ul>
      <HowToUse locale="en">
        <p>You can connect multiple profiles of your children to your account. This way you&apos;ll bundle all information:</p>
      </HowToUse>
    </Page>
  ));
  return pages;
}

ParentTemplate.propTypes = {
  users: PropTypes.array,
  language: PropTypes.string,
};

export default ParentTemplate;
